import { memo, useContext } from 'react'
import { useTranslation } from 'next-i18next'
import Highlighter from 'react-highlight-words'
import { components } from 'react-select'

import { TownhouseIcon } from '@/components/icons'

import Context from './context'
import {
  Address,
  AddressContainer,
  CityStateCountry,
  Container,
  EnterAddress,
  EnterAddressContainer,
  IconContainer,
  InfoContainer,
  markStyle,
  Name,
  StyledArrowRightBlue
} from './option.styles'

const Option = ({
  data,
  selectProps: { wrapBuildingName, newAddressOnClick },
  innerProps,
  ...rest
}) => {
  const { t } = useTranslation()
  const { searchText } = useContext(Context)
  const line2 = `${data.city}, ${data.state}, ${data.zip}`
  const highlight = searchText.split(' ')

  const handleNewAddressClick = value => {
    innerProps?.onClick()
    newAddressOnClick(value)
  }

  return data.isNew ? (
    <EnterAddressContainer
      {...innerProps}
      key={data.value}
      data-testid={`option-${data.id}`}
      onClick={() => handleNewAddressClick(searchText)}
      role="button"
      type="button"
    >
      <EnterAddress>
        {t('l.listing.create.enter_new_address.text', 'Enter new address')}
      </EnterAddress>
      <StyledArrowRightBlue />
    </EnterAddressContainer>
  ) : (
    <components.Option {...rest}>
      <Container {...innerProps}>
        <IconContainer>
          <TownhouseIcon />
        </IconContainer>
        <InfoContainer wrapBuildingName={wrapBuildingName}>
          <AddressContainer>
            <Address>
              <Highlighter
                highlightStyle={markStyle}
                searchWords={highlight}
                autoEscape
                textToHighlight={data.full_street_name}
              />
            </Address>
            <CityStateCountry>
              <Highlighter
                highlightStyle={markStyle}
                searchWords={highlight}
                autoEscape
                textToHighlight={line2}
              />
            </CityStateCountry>
          </AddressContainer>
          <Name>
            <Highlighter
              highlightStyle={markStyle}
              searchWords={highlight}
              autoEscape
              textToHighlight={data.name}
            />
          </Name>
        </InfoContainer>
      </Container>
    </components.Option>
  )
}

export default memo(Option)
